import { apiSlice } from "../../app/api/apiSlice";

export const enhancedConditionRemoveConditionApiSlice =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			enhancedConditionRemoveCondition: builder.mutation({
				query: (credentials) => ({
					url: `/api/v1/loan/enhanced_condition_remove_condition/${credentials?.loanGuid}/`,
					method: "PATCH",
					body: credentials?.data,
				}),
			}),
		}),
	});

export const { useEnhancedConditionRemoveConditionMutation } =
	enhancedConditionRemoveConditionApiSlice;
